import React from 'react';
import styles from './Footer.module.scss'
import { Link } from 'react-router-dom'

export class AppFooter extends React.PureComponent {
  render() {
    return (
      <footer className={styles.AppFooter}>
        <div>
          <p><a href="http://www.greetec.com/?wap=true">切换至电脑版</a></p>
          <p><Link to="/Feedback">投诉与建议</Link></p>
        </div>
        <div>
          <img src={require('img/logo-w.png')} srcSet={`${require("img/logo-w.png")} 1x,${require("img/logo-w@2x.png")} 2x,${require("img/logo-w@3x.png")} 3x`} alt="" />
          <p>Copyright © 2016 青矩技术股份有限公司 </p>
          <p>版权所有 | <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>京ICP备16007407号-1</a> </p>
          <p>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032407" rel="noopener noreferrer" style={{ color: 'inherit' }}>
              <img src={require("@/assets/img/beian.png")} alt="" /> 京公网安备 11010802032407号
            </a>
          </p>
        </div>
      </footer>
    );
  }
}
